export const XProgressBar = ({
  height = 3,
  color = "green",
  backgroundColor = "white",
  percent,
}: {
  height?: number;
  color?: string;
  backgroundColor?: string;
  percent: number;
}) => {
  return (
    <div style={{ height, backgroundColor, position: "relative" }}>
      <div
        style={{
          width: `${percent * 100}%`,
          backgroundColor: color,
          height: "100%",
          transition: "all 0.3s linear",
        }}
      ></div>
    </div>
  );
};
